export enum BIQ_DATA_TYPES {
  STRING = 'STRING',
  BYTES = 'BYTES',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  NUMERIC = 'NUMERIC',
  BIGNUMERIC = 'BIGNUMERIC',
  BOOLEAN = 'BOOLEAN',
  TIMESTAMP = 'TIMESTAMP',
  DATE = 'DATE',
  TIME = 'TIME',
  DATETIME = 'DATETIME',
  GEOGRAPHY = 'GEOGRAPHY',
  RECORD = 'RECORD',
  JSON = 'JSON',
}

export const operationOpts: any = [
  { label: 'SUM', id: 'SUM(%s)' },
  { label: 'AVG', id: 'AVG(%s)' },
  { label: 'COUNT', id: 'COUNT(%s)' },
  { label: 'COUNT(DISTINCT)', id: 'COUNT(DISTINCT %s)' },
  { label: 'MIN', id: 'MIN(%s)' },
  { label: 'MAX', id: 'MAX(%s)' },
  { label: 'ANY_VALUE', id: 'ANY_VALUE(%s)' },
  { label: 'ARRAY_AGG', id: 'ARRAY_AGG(%s)' },
  { label: 'ARRAY_CONCAT_AGG', id: 'ARRAY_CONCAT_AGG(%s)' },
  { label: 'BIT_AND', id: 'BIT_AND(%s)' },
  { label: 'BIT_OR', id: 'BIT_OR(%s)' },
  { label: 'BIT_XOR', id: 'BIT_XOR(%s)' },
  { label: 'COUNTIF', id: 'COUNTIF(%s)' },
  { label: 'LOGICAL_AND', id: 'LOGICAL_AND(%s)' },
  { label: 'LOGICAL_OR', id: 'LOGICAL_OR(%s)' },
  { label: 'STRING_AGG', id: 'STRING_AGG(%s)' },
];

export const whereConditionsOpts = [
  {
    label: '=',
    id: '= %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BOOLEAN,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.GEOGRAPHY,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.JSON,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.RECORD,
      BIQ_DATA_TYPES.STRING,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: '>',
    id: '> %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: '<',
    id: '< %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: '>=',
    id: '>= %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: '<=',
    id: '<= %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: '<>',
    id: '<> %s',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BOOLEAN,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.GEOGRAPHY,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.JSON,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.RECORD,
      BIQ_DATA_TYPES.STRING,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: 'IN',
    id: 'IN(%s)',
    placeholder: 'Valore1, Valore2,...',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BOOLEAN,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.GEOGRAPHY,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.JSON,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.RECORD,
      BIQ_DATA_TYPES.STRING,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: 'NOT IN',
    id: 'NOT IN(%s)',
    placeholder: 'Valore1, Valore2,...',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BOOLEAN,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.GEOGRAPHY,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.JSON,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.RECORD,
      BIQ_DATA_TYPES.STRING,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: 'BETWEEN',
    id: 'BETWEEN %s AND %s',
    placeholder: 'Valore1, Valore2',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    label: 'NOT BETWEEN',
    id: 'NOT BETWEEN %s AND %s',
    placeholder: 'Valore1, Valore2',
    operations: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.BYTES,
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  { label: 'LIKE', id: 'LIKE %s', operations: [BIQ_DATA_TYPES.STRING] },
  { label: 'NOT LIKE', id: 'NOT LIKE %s', operations: [BIQ_DATA_TYPES.STRING] },
];

export const orderByOpts: any = [
  {
    label: 'Ordina Ascendente',
    id: 'asc',
  },
  {
    label: 'Ordina Discendente',
    id: 'desc',
  },
];

export const filterTypes: any[] = [
  {
    type: 'DATE',
    name: 'Range di date',
    valuesType: [
      BIQ_DATA_TYPES.DATE,
      BIQ_DATA_TYPES.DATETIME,
      BIQ_DATA_TYPES.TIME,
      BIQ_DATA_TYPES.TIMESTAMP,
    ],
  },
  {
    type: 'RANGE',
    name: 'Range numerico',
    valuesType: [
      BIQ_DATA_TYPES.BIGNUMERIC,
      BIQ_DATA_TYPES.FLOAT,
      BIQ_DATA_TYPES.INTEGER,
      BIQ_DATA_TYPES.NUMERIC,
    ],
  },
  {
    type: 'SELECT',
    name: 'Lista valori',
    valuesType: [BIQ_DATA_TYPES.STRING],
  },
];

export const validationQuery: any = {
  DATE: { dimensionMin: 0, metricMin: 0, dimensionMax: 0, metricMax: 0 },
  RANGE: {
    dimensionMin: 0,
    metricMin: 2,
    dimensionMax: 0,
    metricMax: 2,
    defaultValue: {
      metricData: [{ operationType: 'MIN(%s)' }, { operationType: 'MAX(%s)' }],
    },
  },
  SELECT: { dimensionMin: 1, metricMin: 0, dimensionMax: 1, metricMax: 0 },
};

export const chartsTypeDisabled: any[] = [
  { code: 'bar', disabled: false },
  { code: 'bar-group', disabled: false },
  { code: 'heatmap', disabled: false },
  { code: 'line', disabled: false },
  { code: 'scorecard', disabled: false },
  { code: 'table', disabled: false },
  { code: 'pie', disabled: false },
  { code: 'doughnut', disabled: false },
  { code: 'hexagon', disabled: false },
  { code: 'violin', disabled: true },
];

export const chartStyleConfig: any = {
  line: [
    {
      label: 'Legenda',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
    {
      label: 'Visualizzazione indicatori',
      classCSS: 'col-6 col-lg-4',
      formControlName: 'indexPoint',
      values: [
        {
          label: 'Mostra',
          value: true,
        },
        {
          label: 'Nascondi',
          value: false,
        },
      ],
    },
    {
      label: 'Visualizzazione linea',
      classCSS: 'col-6 col-lg-4',
      formControlName: 'fill',
      values: [
        {
          label: 'Linea',
          value: false,
        },
        {
          label: 'Area',
          value: true,
        },
      ],
    },
  ],
  bar: [
    {
      label: 'Legenda',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
    {
      label: 'Orientamento barre',
      classCSS: 'col-6 col-lg-4',
      formControlName: 'orientation',
      values: [
        {
          label: 'Verticale',
          value: 'x',
        },
        {
          label: 'Orizzontale',
          value: 'y',
        },
      ],
    },
    {
      label: 'Disposizione barre',
      classCSS: 'col-6 col-lg-4',
      formControlName: 'stacked',
      values: [
        {
          label: 'Affiancate',
          value: false,
        },
        {
          label: 'Impilate',
          value: true,
        },
      ],
    },
  ],
  'bar-group': [
    {
      label: 'Legenda',
      classCSS: 'col-lg-6 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
    {
      label: 'Orientamento barre',
      classCSS: 'col-6 col-lg-6',
      formControlName: 'orientation',
      values: [
        {
          label: 'Verticale',
          value: 'x',
        },
        {
          label: 'Orizzontale',
          value: 'y',
        },
      ],
    },
  ],
  'line-group': [
    {
      label: 'Legenda',
      classCSS: 'col-lg-6 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
  ],
  pie: [
    {
      label: 'Legenda',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
    {
      label: 'Percentuale',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'badge',
      values: [
        {
          label: 'Nascondi',
          value: false,
        },
        {
          label: 'Visualizza',
          value: true,
        },
      ],
    },
  ],
  doughnut: [
    {
      label: 'Legenda',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'legend',
      values: [
        {
          label: 'In alto',
          value: 'top',
        },
        {
          label: 'A destra',
          value: 'right',
        },
      ],
    },
    {
      label: 'Percentuale',
      classCSS: 'col-lg-4 col-12 mb-2',
      formControlName: 'badge',
      values: [
        {
          label: 'Nascondi',
          value: false,
        },
        {
          label: 'Visualizza',
          value: true,
        },
      ],
    },
  ],
  hexagon: [
    {
      label: 'Modalità',
      classCSS: 'col-lg-4 col-md-6 col-sm-12 mb-2',
      formControlName: 'view3D',
      values: [
        {
          label: '2D',
          value: false,
        },
        {
          label: '3D',
          value: true,
        },
      ],
    },
  ],
  scorecard: [],
};

export const defaultOptionsChartValue: any = {
  orientation: 'x',
  legend: 'top',
  stacked: false,
  badge: false,
  indexPoint: true,
  view3D: false,
  paletteColor: [
    [255, 255, 178],
    [254, 217, 118],
    [254, 178, 76],
    [253, 141, 60],
    [240, 59, 32],
    [189, 0, 38],
  ],
  fill: false,
  colorBasemap: 'osm',
  backgroundColors: [
    '#eb1e2c',
    '#fd6f30',
    '#f9a729',
    '#f9d23c',
    '#5fbb68',
    '#64cdcc',
    '#91dcea',
    '#a4a4d5',
    '#bbc9e5',
  ],
  latitude: 42.08086356352814,
  longitude: 16.710510948592404,
  zoom: 4,
};
